<template>
  <div
    :class="{ 'playing': isPlaying }"
  >
    <font-awesome-icon
      :icon="['fas', 'users']"
      class="mr-1"
    />
    {{ count }}
    <font-awesome-icon
      v-if="isPlaying"
      :icon="['fas', 'check']"
      class="ml-2"
    />
  </div>
</template>

<script>
export default {
  name: 'UsersCount',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.playing {
  color: $success;
}
</style>
